import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 px-4 bg-cream text-center" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-25">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-sage" data-id="element-26">
            LLÉVATELO HOY POR SOLO
          </h2>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-27">
            <span className="text-2xl md:text-3xl text-espresso/40 line-through font-semibold" data-id="element-28">
              $17.00
            </span>
            <span className="text-5xl md:text-6xl font-bold text-terracotta" data-id="element-29">
              $6.39
            </span>
          </div>
          <p className="text-lg md:text-xl mb-10 text-espresso/80" data-id="element-30">
            Un solo pago. Sin suscripciones. Menos que un café en Starbucks para
            transformar todas tus mañanas.
          </p>

          <div className="mb-8" data-id="element-31">
            <Button onClick={() => window.open('https://www.varenli.com/cart/42519328194654:1', '_blank')} className="text-xl md:text-2xl py-5 px-10 shadow-warm-lg hover:shadow-xl transform transition-all" data-id="element-32">
              ¡SÍ, QUIERO MI RECETARIO AHORA!
            </Button>
          </div>

          <div className="flex items-center justify-center gap-3 text-espresso/70 text-lg" data-id="element-33">
            <ShieldCheckIcon className="w-6 h-6 text-sage" data-id="element-34" />
            <span data-id="element-35">
              Pago seguro y descarga inmediata incluso si son las 2:00 AM.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}